import { render } from "./MoreMenu.vue?vue&type=template&id=cdc0387c"
import script from "./MoreMenu.vue?vue&type=script&lang=js"
export * from "./MoreMenu.vue?vue&type=script&lang=js"

import "./MoreMenu.vue?vue&type=style&index=0&id=cdc0387c&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__